import { EventPaymentProcessor } from "@/modules/event/types/event"
import { AutoFillFields } from "@/modules/shared/types/shared"

export const handleCheckoutPageUrl = (router) => {
  if (typeof(router.query.eventId) !== 'undefined') {
    router.push(`/event/${router.query.eventId}/checkout`)
  }
  if (typeof(router.query.token) !== 'undefined') {
    router.push(`/entry/${router.query.token}/checkout`)
  }
}

export const isStripeProcessor = (
  processor: EventPaymentProcessor | undefined
) => {
  return (
    processor !== undefined &&
    [EventPaymentProcessor.Stripe, EventPaymentProcessor.Stripe_EU].includes(
      processor
    )
  )
}

export const autoCompleteFields = () => {
  return Object.keys(AutoFillFields).reduce((carry, item) => {
    carry[AutoFillFields[item]] = {
      autoComplete: AutoFillFields[item],
    }

    return carry
  }, {})
}
